import React from 'react'

const Spinner = props => (
    <div className="spinner-border" role="status">
    </div>
)

export default Spinner